import React from "react";
import CylinderSvg from "./CylinderSvg";

/* Height mapping by cylinder capacity */
/* Height mapping by cylinder capacity - REDUCED SIZES */
const HEIGHTS = {
  "5KG": 60,      // Smallest (was 80)
  "14.2KG": 80,   // Medium (was 105)
  "19KG": 95,     // Large (was 120)
  "47KG": 110,    // Largest (was 145)
};

/* Width mapping by cylinder capacity - REDUCED SIZES */
const WIDTHS = {
  "5KG": 38,      // Narrowest (was 50)
  "14.2KG": 50,   // Medium width (was 66)
  "19KG": 55,     // Wider (was 72)
  "47KG": 66,     // Widest (was 87)
};

/* Normalize incoming weight label */
const normalizeWeight = (w = "") => {
  const val = w.toString();
  if (val.includes("5")) return "5KG";
  if (val.includes("14")) return "14.2KG";
  if (val.includes("19")) return "19KG";
  if (val.includes("47")) return "47KG";
  return "19KG";
};

const CylinderInventoryProgress = ({
  fulls = 0,
  empties = 0,
  weight,
}) => {
  const total = Number(fulls) + Number(empties);
  const fillRatio = total > 0 ? Number(fulls) / total : 0;
  const normalizedWeight = normalizeWeight(weight);

  /* Pick correct height and width */
  const cylinderHeight = HEIGHTS[normalizedWeight] || 120;
  const cylinderWidth = WIDTHS[normalizedWeight] || 70;

  return (
    <div style={styles.container}>
      {/* Total */}
      <div style={styles.totalText}>
        {total}
      </div>

      {/* Cylinder - Fixed height wrapper for consistent bottom alignment */}
     <div style={{
  ...styles.cylinderWrapper,
  height: `${HEIGHTS["47KG"]}px`, // This will now be 110px instead of 145px
  position: 'relative',
}}>
        {/* Cylinder positioned at bottom */}
        <div style={{
          position: 'absolute',
          bottom: 0,
          width: `${cylinderWidth}px`,
          height: `${cylinderHeight}px`,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'flex-end',
        }}>
          <CylinderSvg
            fillRatio={fillRatio}
            fulls={fulls}
            empties={empties}
            height={cylinderHeight}
          />
        </div>
      </div>

      {/* Labels with bottom padding */}
      <div style={styles.labelContainer}>
        <div style={styles.weightLabel}>
          {normalizedWeight}
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "flex-end",
    height: "100%",
    minWidth: "50px",  // Reduced from 60px
    maxWidth: "75px",  // Reduced from 90px
    flexShrink: 0,
    padding: "0 3px",  // Reduced from 5px
  },
  totalText: {
    fontWeight: 900,
    fontSize: "10px",  // Reduced from 11px
    marginBottom: "4px",  // Reduced from 6px
    color: "#1e293b",
    textAlign: "center",
    width: "100%",
    flexShrink: 0,
  },
  cylinderWrapper: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-end",
    marginBottom: "6px",  // Reduced from 10px
    flexShrink: 0,
  },
  labelContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "flex-start",
    width: "100%",
    paddingBottom: "3px",  // Reduced from 5px
    flexShrink: 0,
  },
  weightLabel: {
    fontWeight: 800,
    fontSize: "10px",  // Reduced from 11px
    color: "#334155",
    textAlign: "center",
    width: "100%",
    marginBottom: "2px",
  },
  detailsLabel: {
    fontSize: "8px",  // Reduced from 9px
    opacity: 0.7,
    color: "#64748b",
    textAlign: "center",
    width: "100%",
  },
};

export default CylinderInventoryProgress;